import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
type PageType = 'home' | 'commercial' | 'services' | 'residential';
interface FooterProps {
  currentPage: PageType;
  onNavigate: (page: PageType, sectionId?: string) => void;
}
const navItems: {
  label: string;
  page: PageType;
  sectionId?: string;
}[] = [{
  label: 'HOME',
  page: 'home'
}, {
  label: 'SLUŽBY',
  page: 'services'
}, {
  label: 'KOMERČNÍ ŘEŠENÍ',
  page: 'commercial'
}, {
  label: 'REZIDENTNÍ ŘEŠENÍ',
  page: 'residential'
}, {
  label: 'O NÁS',
  page: 'home',
  sectionId: 'onas'
}, {
  label: 'KONTAKT',
  page: 'home',
  sectionId: 'kontakt'
}];
const socialLinks = [{
  icon: LinkedinIcon,
  href: 'https://www.linkedin.com/company/langard-s-r-o-/?viewAsMember=true',
  label: 'LinkedIn'
}, {
  icon: InstagramIcon,
  href: 'https://www.instagram.com/langard_cz',
  label: 'Instagram'
}, {
  icon: FacebookIcon,
  href: 'https://www.facebook.com/LANGARDsro',
  label: 'Facebook'
}];
export function Footer({
  currentPage,
  onNavigate
}: FooterProps) {
  const handleNavClick = (item: (typeof navItems)[0]) => {
    if (item.sectionId && currentPage === 'home') {
      const el = document.getElementById(item.sectionId);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    } else if (item.sectionId) {
      onNavigate(item.page, item.sectionId);
    } else {
      onNavigate(item.page);
    }
  };
  return <footer className="w-full bg-[#2a2a2a] text-white" data-id="element-143">
      <div className="max-w-6xl mx-auto px-6 py-12" data-id="element-144">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start" data-id="element-145">
          {/* Logo */}
          <div data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/k5fHHKued9vuhivXuUB9Kx/LOGO_LANGARD.svg" alt="LANGARD" className="h-8 w-auto brightness-0 invert opacity-50" data-id="element-147" />
          </div>

          {/* Navigation Links */}
          <nav data-id="element-148">
            <ul className="space-y-2" data-id="element-149">
              {navItems.map(item => <li key={item.label} data-id="element-150">
                  <button onClick={() => handleNavClick(item)} className="text-sm text-[#808080] hover:text-[#b0b0b0] transition-colors" data-id="element-151">
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </nav>

          {/* Social Links */}
          <div className="flex items-center gap-3 md:justify-end" data-id="element-152">
            {socialLinks.map(social => <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.label} className="w-9 h-9 rounded-full bg-[#444] flex items-center justify-center hover:bg-[#555] transition-colors" data-id="element-153">
                <social.icon className="w-4 h-4 text-[#999]" data-id="element-154" />
              </a>)}
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-[#3a3a3a]" data-id="element-155">
        <div className="max-w-6xl mx-auto px-6 py-4" data-id="element-156">
          <p className="text-right text-sm text-[#666]" data-id="element-157">
            Všechna práva vyhrazena (c) 2026
          </p>
        </div>
      </div>
    </footer>;
}